import axios from 'axios';
import { API_CORE_URL } from '../constantes/constantes';

/**
 * Obtiene el JSON correspondiente al carrusel de un equipo o evento.
 *
 * @param {Object} params - Parámetros para construir la URL.
 * @param {string} params.typeJson - Tipo de JSON (por ejemplo, 'data').
 * @param {string} params.sport - Tipo de deporte (por ejemplo, 'futbol').
 * @param {string} params.idEvent - ID del evento o equipo.
 * @param {string} params.type - Tipo de recurso ('sport' o 'team').
 * @param {string} [params.sort] - Dirección del ordenamiento (por ejemplo, 'asc' o 'desc').
 * @param {number} [params.limit] - Límite de resultados a retornar.
 * @param {string} [params.time] - Filtro de tiempo (por ejemplo, 'feature' o 'past').
 * @returns {Promise<{ data: any, statusCode: number }>} Objeto con los datos o estado del error.
 */
export async function getCarrouselTeam({ typeJson, sport, idEvent, type, version }) {
  let sort= typeJson === "results" ? "desc" : "asc";
  const limit= 15;
  let time= typeJson === "results" ? typeJson : "feature";
  let type2=  type === "teams" ? "team": type;
  let country = version;

  try {
    const url = `${API_CORE_URL}events/${type2}/${idEvent}`;

    const { data, status } = await axios.get(url, {
      timeout: 25000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json; charset=utf-8',
      },
      params: {
        ...(sort !== undefined && { sort }),
        ...(limit !== undefined && { limit }),
        ...(time !== undefined && { time }),
        ...(country === 'us' && {country})
      },
    });

    const responseData = typeJson === 'results' ? [...data].reverse() : data;

    return { statusCode: status, data: responseData };
  } catch (error) {
    console.error('Error en la petición:', error.message || error);

    const status = error.response?.status || 500;
    return { statusCode: status, data: [] };
  }
}